export type VuetifyColor =
  | "accent"
  | "primary"
  | "warning"
  | "success"
  | "error";

/**
 * Mapovani ID typu vozidla (VehicleType.Id) na Vuetify barvu, kterou se
 * obarvuji sloty/kategorie podle typu vozidla.
 *
 * Puvodne se barva odvozovala z textove zkratky typu vozidla (viz git
 * historie), coz se rozbijelo pri jakekoli zmene nazvu. Napred se pouziva
 * stabilni ID typu vozidla.
 */
export const VEHICLE_TYPE_COLOR_BY_ID: Readonly<Record<number, VuetifyColor>> =
  {
    1: "accent",
    2: "primary",
    3: "warning",
    4: "success",
    5: "error",
    6: "warning",
    7: "success",
    8: "primary",
    9: "primary",
    10: "success",
    11: "success",
    12: "success",
    13: "success",
    14: "success",
    15: "primary",
    16: "primary",
    17: "warning",
    18: "primary",
  };

export const DEFAULT_VEHICLE_TYPE_COLOR: VuetifyColor = "error";

/** Hex ekvivalent ke kazde Vuetify barve, pro "ztlumene" pozadi slotu. */
export const DIM_HEX_BY_VUETIFY_COLOR: Readonly<Record<VuetifyColor, string>> =
  {
    accent: "#bfe8ea",
    primary: "#c4d1e2",
    warning: "#fce5c5",
    success: "#B7E5CE",
    error: "#f5c8d2",
  };

export function getVuetifyColorForVehicleTypeId(
  vehicleTypeId?: number | null
): VuetifyColor {
  if (vehicleTypeId == null) {
    return DEFAULT_VEHICLE_TYPE_COLOR;
  }
  return VEHICLE_TYPE_COLOR_BY_ID[vehicleTypeId] ?? DEFAULT_VEHICLE_TYPE_COLOR;
}
